import { render } from "./CustomRadioButton.vue?vue&type=template&id=8a32560e"
import script from "./CustomRadioButton.vue?vue&type=script&lang=js"
export * from "./CustomRadioButton.vue?vue&type=script&lang=js"

import "./CustomRadioButton.vue?vue&type=style&index=0&id=8a32560e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__